import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import ThemeBackground from '../components/ThemeBackground';
import ProfileForm from '../components/ProfileForm';

const Profile = () => {
  const navigate = useNavigate();
  const { hasProfile } = useAuth();
  const [profileSaved, setProfileSaved] = useState(false);

  const handleProfileComplete = () => {
    setProfileSaved(true);
    
    // Redirigir a la página principal después de un breve retraso
    setTimeout(() => {
      navigate('/');
    }, 2000);
  };

  return (
    <div className="relative min-h-screen overflow-hidden">
      <ThemeBackground />
      <div className="absolute inset-0 z-10 flex items-center justify-center">
        <div className="w-full max-w-3xl p-4 sm:p-6 py-10">
          {profileSaved ? (
            <div className="bg-gradient-to-br from-gray-900/90 to-gray-800/80 backdrop-blur-sm rounded-xl border border-gray-700/30 p-6 text-center">
              <div className="w-16 h-16 bg-green-500/20 rounded-full mx-auto flex items-center justify-center mb-4">
                <svg className="w-8 h-8 text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <h2 className="text-2xl font-semibold text-white mb-2">¡Perfil Actualizado!</h2>
              <p className="text-gray-300 mb-4">
                Tu perfil ha sido guardado correctamente. 
                {!hasProfile && " Ahora puedes disfrutar de todas las funciones."}
              </p>
              <p className="text-gray-400 text-sm">
                Redirigiendo a la página principal...
              </p>
            </div>
          ) : (
            <>
              {!hasProfile && (
                <div className="text-center mb-8">
                  <h1 className="text-4xl font-bold text-white mb-4 flex justify-center items-center">
                    Bienvenido a <span className="text-blue-400 ml-2">ToWatch</span>
                    <div className="w-10 h-10 ml-3 bg-blue-500/20 rounded-lg flex items-center justify-center">
                      <svg className="w-6 h-6 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
                      </svg>
                    </div>
                  </h1>
                  <p className="text-gray-300 max-w-2xl mx-auto">
                    Para comenzar, necesitamos que configures tu perfil. Esto nos permitirá mostrarte correctamente en el chat y otras funciones de la aplicación.
                  </p>
                </div>
              )}
              
              <ProfileForm onComplete={handleProfileComplete} />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Profile; 